import LookUpModel from "./LookUpModel";

export default class AddressTypeModel extends LookUpModel {
    constructor(data: Partial<AddressTypeModel>) {
        super(data);

        this.update(data);
    }
}
